export default {
    md: 'markdown',
    js: 'javascript',
    jsx: 'javascript',
    jsm: 'javascript',
    ts: "typescript",
    tsm: "typescript",
    tsx: "typescript",
    html: 'xml',
    svg: 'xml',
    htm: 'xml',
    xhtml: 'xml',
    iml: 'xml',
    vue: 'xml',
    yml: 'yaml',
    py: 'python',
    css: 'scss',
    sass: 'yaml',
    cs: 'csharp',
    env: 'properties',
    txt: "text",
    h: "c",
    ino: "c",
}